import { IDadosCheque, IPagamentoRow } from 'pages/pagamento/pagamento.model';

const isDadosChequeIncompletos = (cheque: IDadosCheque) =>
    !cheque.banco?.uuid ||
    !cheque.agencia ||
    !cheque.numeroCheque ||
    !cheque.emitente ||
    !cheque.vencimento;

export const isChequeSemDados = (row: IPagamentoRow) => {
    if (row.name !== 'CHEQUE') return false;
    const dadosCheque = row.infoAdicional?.dadosCheque;
    if (!dadosCheque?.length) return true;
    return dadosCheque.some(isDadosChequeIncompletos);
};

export const removeChequesSemDados = (itens: Array<IPagamentoRow>) => {
    const itensValidos = itens.filter(item => !isChequeSemDados(item));
    return { itens: itensValidos, removidos: itens.length - itensValidos.length };
};
